import { BaseService } from "./base.service";
import { ErrorWrapper, ResponseWrapper } from "./util";

export class SubscriptionService extends BaseService {
  static get entity() {
    return "subscription";
  }

  static async getUserSubscriptions() {
    try {
      const response = await this.request({ auth: true }).get(
        `/subscriptions`,
        {
          baseURL: process.env.VUE_APP_EAD_API_URL,
        }
      );
      return new ResponseWrapper(
        { status: 200, data: { success: true } },
        response.data
      );
    } catch (error) {
      const message =
        error.response?.data && typeof error.response?.data === "object"
          ? error.response?.data.error
          : error.message;
      throw new ErrorWrapper(error, message);
    }
  }

  static async generateToken() {
    try {
      const response = await this.request({ auth: true }).get(
        '/subscriptions/generate-token',
        { baseURL: process.env.VUE_APP_EAD_API_URL }
      );
      if (response.status === 204) {
        return new ResponseWrapper({ status: 204, data: { success: false } }, null);
      }
      return new ResponseWrapper(
        { status: 200, data: { success: true } },
        response.data
      );
    } catch (error) {
      const message =
        error.response && error.response?.data && typeof error.response?.data === 'object'
          ? error.response?.data.error
          : error.message;
      throw new ErrorWrapper(error, message);
    }
  }

  static async cancelSubscription(subscriptionId) {
    try {
      const response = await this.request({ auth: true }).post(
        `/subscriptions/${subscriptionId}/cancel`,
        null,
        {
          baseURL: process.env.VUE_APP_EAD_API_URL,
        }
      );
      return new ResponseWrapper(
        { status: 200, data: { success: true } },
        response.data
      );
    } catch (error) {
      const message =
        error.response?.data && typeof error.response?.data === "object"
          ? error.response?.data.error
          : error.message;
      throw new ErrorWrapper(error, message);
    }
  }
}
